export default "__VITE_ASSET__0cab7954__"